import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoading } from 'src/contexts/LoadingContext';
import { get_crm_logo_favicon } from '../ApiServices';
// ----------------------------------------------------------------------

export default function ScrollToTop() {
  const { pathname } = useLocation();

  const { loadingStates } = useLoading();
  useEffect(() => {
    const fetchCrmAssets = async () => {
      try {
        const res = await get_crm_logo_favicon();

        if (res?.data?.length) {
          // CRM FAVICON
          const favicon = res.data.find((item) => item.key === 'website_crm_favicon');

          if (favicon?.value) {
            let link =
              document.querySelector("link[rel~='icon']") || document.createElement('link');

            link.rel = 'icon';
            link.type = 'image/png';
            link.href = favicon?.value;

            document.head.appendChild(link);
          }
        }
      } catch (error) {
        console.error('Failed to load CRM assets:', error);
      }
    };

    fetchCrmAssets();
  }, [loadingStates.loadingFav]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
